// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".col_left[data-v-34a5fb7e],\n.col_right[data-v-34a5fb7e] {\n  max-height: 70vh;\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
